import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-instant-notification-form',
  templateUrl: './instant-notification-form.component.html',
  styleUrls: ['./instant-notification-form.component.scss']
})
export class InstantNotificationFormComponent implements OnInit {

  public data: any = {code: null, title: null}

  
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      if (params['uuid']) {
        this.init(params['uuid']);
      } else {
        this.newCode();
      }
    });
  }

  ngOnInit(): void {
  }

  async init(uuid = null) {
    this.data = await this.http.post('/admin/setting/instant-notificatoin/get/single', {uuid});
  }

  newCode() {
    var milliseconds = new Date().getTime();
    this.data.code = milliseconds;
  }

  async submit() {
    if (!this.data.title) {
      return;
    }

    const s = await this.http.post("/admin//setting/instant-notificatoin/update", this.data)

    if (s['status']) {
      this.http.notify("Notification update successfully.")
      this.http.naviBack();
    }
  }
}
